import { FonteService } from "../../services/FonteService";
import { ExercicioService } from "../../services/ExercicioService";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";

export default {
    name: "GerenciarFontes",
    components: {
        StandardPagination,
        ActionButtons,
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Fontes',
                disabled: true
            }
        ],
    // Controle de responsividade
    isMobile: false,
    isTablet: false,
    windowWidth: 0,
        baseHeaders: [
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', sortable: false },
            { text: 'Código Fonte', align: 'center', value: 'codigo_fonte', sortable: false },
            { text: 'Descrição', align: 'center', value: 'descricao', sortable: false },
            { text: 'Status', align: 'center', value: 'ativo', sortable: false },
        ],
        filters: {
            codigoFonteFilter: '',
            descricaoFonteFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        showFilters: true
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
    // Headers computados - sempre mostra todas as colunas
    computedHeaders() {
      // Sempre retorna todas as colunas, independente da resolução
      // O scroll horizontal cuidará da navegação em telas pequenas
      return this.baseHeaders || this.headers;
    },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
  ,
        canActivateSelected() {
            // Só pode ativar se houver itens selecionados E pelo menos um estiver inativo
            return this.itemSelected.length > 0 && this.itemSelected.some(item => !item.ativo);
        },
        canDeactivateSelected() {
            // Só pode desativar se houver itens selecionados E pelo menos um estiver ativo
            return this.itemSelected.length > 0 && this.itemSelected.some(item => item.ativo);
        }
    },
    created() {
        this.listarFontesPaginado();
        this.listarExerciciosSelect();
    },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarFontesPaginado();
        },
        'filters.codigoFonteFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarFontesPaginado();
            }
        },
        'filters.descricaoFonteFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarFontesPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarFontesPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarFontesPaginado();
            }
        }
    },
    methods: {
        async listarFontesPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();
                const response = await FonteService.index(filter);

                if (response && response.data) {
                    // Verificar se a resposta tem estrutura aninhada
                    if (response.data.data) {
                        this.items = response.data.data;
                        this.totalItems = response.data.total;
                    } else {
                        this.items = response.data;
                        this.totalItems = response.total || response.data.length;
                    }
                    
                    // Limpar seleção ao carregar novos dados
                    this.itemSelected = [];
                } else {
                    console.error('Não foi possível listar as fontes.');
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as fontes:', error);
                this.items = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os fontes.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os fontes:', error);
            }
        },
        async destroyFontes() {
            try {
                if (this.itemSelected.length === 0) {
                    this.$globalAlert('Nenhum item selecionado para excluir.');
                    return;
                }

                const ids = this.itemSelected.map(fonte => fonte.id);
                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("fontes[]", id);
                });

                const response = await FonteService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os fontes.');
                } 

            } catch (error) {
                console.error('Ocorreu um erro ao excluir os fontes:', error);
            }
        },

        // Métodos para paginação padronizada
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarFontesPaginado();
        },

        // Método para selecionar/deselecionar todos os itens
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                // Garantir que estamos selecionando itens com id válido
                const itemsComId = this.items.filter(item => item.id !== undefined && item.id !== null);
                this.itemSelected = [...itemsComId];
            }
        },

        clearSelection() {
            this.itemSelected = [];
        },

        // Método para truncar texto longo
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },
        async activateFontes() {
            try {
                // Validação adicional para garantir que só ativa itens inativos
                const fontesParaAtivar = this.itemSelected.filter(fonte => !fonte.ativo);
                
                if (fontesParaAtivar.length === 0) {
                    this.$globalAlert('Nenhum item inativo selecionado para ativar.');
                    return;
                }

                const ids = fontesParaAtivar.map(fonte => fonte.id);
                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("fontes[]", id);
                });

                const response = await FonteService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os fontes.');
                    this.$globalAlert('Erro ao ativar os fontes selecionados.');
                } else {
                    this.clearSelection();
                    this.listarFontesPaginado();
                }
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os fontes:', error);
                this.$globalAlert('Erro ao ativar os fontes selecionados.');
            }
        },
        async deactivateFontes() {
            try {
                // Validação adicional para garantir que só desativa itens ativos
                const fontesParaDesativar = this.itemSelected.filter(fonte => fonte.ativo);
                
                if (fontesParaDesativar.length === 0) {
                    return;
                }

                const ids = fontesParaDesativar.map(fonte => fonte.id);
                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("fontes[]", id);
                });

                const response = await FonteService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os fontes.');
                    this.$globalAlert('Erro ao desativar os fontes selecionados.');
                } else {
                    this.clearSelection();
                    this.listarFontesPaginado();
                }
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os fontes:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        navigateToCreate() {
            this.$router.push('/fontes/criar');
        },

        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/fontes/editar/${this.itemSelected[0].id}`);
            }
        },

        handleExport() {
            this.$globalAlert('Funcionalidade de exportação não implementada ainda!');
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            this.filters.codigoFonteFilter
                ? filter.append(
                    "codigo_fonte",
                    this.filters.codigoFonteFilter
                )
                : null;

            this.filters.descricaoFonteFilter
                ? filter.append(
                    "descricao",
                    this.filters.descricaoFonteFilter
                )
                : null;

            this.filters.exercicioFilter
                ? filter.append(
                    "exercicio",
                    this.filters.exercicioFilter
                )
                : null;

            this.filters.statusFilter !== null
                ? filter.append(
                    "ativo",
                    this.filters.statusFilter
                )
                : null;

            return filter;
        },

        // Método para aplicar classes nas linhas baseado no status
        getRowClass(item) {
            return item.ativo ? 'active-row' : 'inactive-row';
        },

        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};
